import './headerCarousel.scss'

import { Carousel, CarouselProps } from '../../subcomponents'
import React, { FunctionComponent, useRef, useState } from 'react'

import { CmsImage } from '../../feComponents'
import { HeaderCarouselPropsApi } from './models'
import { navigationService } from '../../'
import { newLineDelimiter } from '../../utilities'
import { Icon, Button, ButtonColor } from '@vista-digital/occ-ui'

export interface HeaderCarouselProps {
    slides: HeaderCarouselPropsApi[]
}

export const HeaderCarouselComponent: FunctionComponent<HeaderCarouselProps> = props => {
    const { slides } = props

    const validSlides = slides.filter(s => !!s?.slideImage)

    // COMS-4106 Next/Previous buttons stop working / useRef instead of createRef !
    const swiperRef: any = useRef(null)

    const hasMultipleSlides: boolean = validSlides && validSlides.length > 1

    const [currentIndex, setCurrentIndex] = useState(0)

    const carouselPropsFinal: CarouselProps = {
        carouselProps: {
            swiperConfig: {
                slidesPerView: 'auto',
                spaceBetween: 0,
                centeredSlides: true,
                loop: hasMultipleSlides,
                autoplay: hasMultipleSlides
                    ? {
                          delay: 8000,
                          disableOnInteraction: false,
                      }
                    : false,
                onActiveIndexChange: () => {
                    let index = swiperRef?.current?.swiper?.activeIndex ?? 0
                    index = index % validSlides.length
                    setCurrentIndex(index)
                },
            },
        },
    }

    const handleRightClick = () => {
        swiperRef.current.swiper.slideNext()
    }

    const handleLeftClick = () => {
        swiperRef.current.swiper.slidePrev()
    }

    const goToSlide = index => {
        swiperRef.current.swiper.slideTo(index)
    }

    if (!validSlides || !validSlides.length) return null

    return (
        <div className="header-carousel bottom-spacing">
            <div className="swiper-container container-lg container-lg-padding">
                <Carousel ref={swiperRef} {...carouselPropsFinal}>
                    {validSlides.map((slide, index) => {
                        if (!slide.slideImage || index >= 8) return null // no more than 8 slides allowed the client says

                        return (
                            <div key={'slide-container-key' + index} className="slide-container">
                                <div className="slide-container-image">
                                    <CmsImage class="slide-image" image={slide.slideImage} />
                                </div>
                                <div className="slide-container-overlay container-lg-padding">
                                    <div className="slide-container-overlay-title">
                                        {slide.heading && (
                                            <div className="slide-text-heading-wrapper">
                                                <h6 className="slide-text-heading">{slide.heading}</h6>
                                            </div>
                                        )}
                                        {slide.title && (
                                            <h2 className="slide-text-title">{newLineDelimiter(slide.title)}</h2>
                                        )}
                                        {slide.subTitle && (
                                            <h4 className="slide-text-subtitle">{newLineDelimiter(slide.subTitle)}</h4>
                                        )}
                                    </div>
                                    <div className="slide-container-overlay-navigation">
                                        {slide?.link && (
                                            <Button
                                                color={ButtonColor.Primary}
                                                label={slide.link.name}
                                                onClick={() =>
                                                    navigationService.goTo(
                                                        slide.link.url,
                                                        slide.link.target === '_blank' ? true : false
                                                    )
                                                }
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </Carousel>
                <div className="header-carousel-controls-wrapper">
                    <div className="header-carousel-controls">
                        <div className="header-carousel-controls__pagination">
                            {validSlides.length > 1 &&
                                validSlides.map((slide, index) => (
                                    <hr
                                        className={`${currentIndex === index ? 'active' : ''}`}
                                        key={index}
                                        onClick={() => goToSlide(index)}
                                    />
                                ))}
                        </div>
                        <div className="header-carousel-controls__arrow-left" onClick={handleLeftClick}>
                            {validSlides.length > 1 && <Icon name="arrowLeft" />}
                        </div>
                        <div className="header-carousel-controls__arrow-right" onClick={handleRightClick}>
                            {validSlides.length > 1 && <Icon name="arrowRight" />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderCarouselComponent
